/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"

import Header from "./header"
import Footer from "./footer"
import "./main.scss"

const Layout = ({ children, className }) => {
  return (
    <div className={`site-grid ${className}`}>
      <link
        href="https://fonts.googleapis.com/css?family=Open+Sans|Roboto|Roboto+Condensed"
        rel="stylesheet"
      />
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
